/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SalesOrderItemSummary } from './SalesOrderItemSummary';
import {
    SalesOrderItemSummaryFromJSON,
    SalesOrderItemSummaryFromJSONTyped,
    SalesOrderItemSummaryToJSON,
    SalesOrderItemSummaryToJSONTyped,
} from './SalesOrderItemSummary';

/**
 * 
 * @export
 * @interface PagedResultSalesOrderItemSummary
 */
export interface PagedResultSalesOrderItemSummary {
    /**
     * 
     * @type {Array<SalesOrderItemSummary>}
     * @memberof PagedResultSalesOrderItemSummary
     */
    content: Array<SalesOrderItemSummary>;
    /**
     * 
     * @type {number}
     * @memberof PagedResultSalesOrderItemSummary
     */
    totalElements: number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultSalesOrderItemSummary
     */
    totalPages: number;
}

/**
 * Check if a given object implements the PagedResultSalesOrderItemSummary interface.
 */
export function instanceOfPagedResultSalesOrderItemSummary(value: object): value is PagedResultSalesOrderItemSummary {
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('totalElements' in value) || value['totalElements'] === undefined) return false;
    if (!('totalPages' in value) || value['totalPages'] === undefined) return false;
    return true;
}

export function PagedResultSalesOrderItemSummaryFromJSON(json: any): PagedResultSalesOrderItemSummary {
    return PagedResultSalesOrderItemSummaryFromJSONTyped(json, false);
}

export function PagedResultSalesOrderItemSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PagedResultSalesOrderItemSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'content': ((json['content'] as Array<any>).map(SalesOrderItemSummaryFromJSON)),
        'totalElements': json['totalElements'],
        'totalPages': json['totalPages'],
    };
}

export function PagedResultSalesOrderItemSummaryToJSON(json: any): PagedResultSalesOrderItemSummary {
    return PagedResultSalesOrderItemSummaryToJSONTyped(json, false);
}

export function PagedResultSalesOrderItemSummaryToJSONTyped(value?: PagedResultSalesOrderItemSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'content': ((value['content'] as Array<any>).map(SalesOrderItemSummaryToJSON)),
        'totalElements': value['totalElements'],
        'totalPages': value['totalPages'],
    };
}

